import Model from './Model'

export const tags = {
  GENERAL: 'general',
  PAYMENTS: 'payments',
  DISTRIBUTIONS: 'distributions',
  DK_INTERNAL: 'dk_internal',
}

class VirtualBankAccount extends Model {
  constructor (initialData) {
    super(initialData, {
      momentKeys: [
        'created_at',
        'updated_at',
      ],
    })
  }

  get isExternalDistributionAllowed () {
    return !this.internal_only
  }
}

export default VirtualBankAccount
